import React, { useEffect, useState } from 'react';
import { TextField } from '@mui/material';
import toastr from 'toastr';
import GridAutocomplete from './GridAutocomplete';
import { getLookup, clearLookupCache } from '../../services/clinicPortalServices/lookupService';
import { addLabHubItem } from '../../services/clinicPortalServices/labHubService';
import { getUserRole } from '../../services/common/util';

const LIST_NAMES = { units: 'Units of Measure', specimenTypes: 'Specimen Types', race: 'Race', ethnicity: 'Ethnicity', relation: 'Relation to Insured', symptoms: 'Symptoms' };

// One field for any Lookup List: type-ahead + grid browse. Saves the item value, shows its label.
// onChange(value, syntheticEvent). freeSolo allows typing a value that is not in the list.
export default function LookupField({ lookup, label, value, onChange, name, freeSolo = false, error, helperText, disabled, required }) {
    const [items, setItems] = useState([]);
    const load = () => getLookup(lookup).then((d) => setItems(d || []));
    useEffect(() => {
        let alive = true;
        getLookup(lookup).then((d) => { if (alive) setItems(d || []); });
        return () => { alive = false; };
    }, [lookup]);
    const labelOf = (v) => { const it = items.find((i) => i.value === v); return it ? it.label : v || ''; };
    const emit = (v) => { const val = v == null ? '' : v; if (onChange) onChange(val, { target: { name, value: val }, persist: () => {} }); };
    const listName = LIST_NAMES[lookup] || lookup;
    const typed = String(value || '').trim();
    const notInList = freeSolo && typed && items.length > 0 && !items.some((i) => i.value === typed || String(i.label).toLowerCase() === typed.toLowerCase());
    const isAdmin = /^superadmin|^admin/.test(String(getUserRole() || '').toLowerCase());
    const addToList = () => {
        addLabHubItem(lookup, { value: typed, label: typed })
            .then((res) => {
                if (res && res.success === false) { toastr.error(res.message || 'Could not add'); return; }
                clearLookupCache(lookup);
                load();
                toastr.success(`"${typed}" added to ${listName}`);
            })
            .catch(() => toastr.error('Could not add'));
    };
    return (
        <div>
            <GridAutocomplete
                freeSolo={freeSolo}
                disabled={disabled}
                options={items.map((i) => i.value)}
                getOptionLabel={(v) => labelOf(v)}
                value={value || null}
                onChange={(e, v) => emit(v)}
                onInputChange={freeSolo ? (e, v, reason) => { if (reason === 'input') emit(v); } : undefined}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        required={required}
                        error={error}
                        fullWidth
                        helperText={helperText || (notInList ? `"${typed}" isn't in the ${listName} list. It will be saved as typed.` : undefined)}
                    />
                )}
            />
            {notInList && isAdmin && !disabled && (
                <button type="button" className="btn btn-link btn-sm p-0" style={{ fontSize: 12 }} onClick={addToList}>
                    <i className="fas fa-plus mr-1"></i>Add "{typed}" to the {listName} list
                </button>
            )}
        </div>
    );
}
